import React from "react";
import moment from "moment";
import Select from 'react-select';
import Notify from '../Notify.js';
import ReactExport from "react-data-export";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

class VendedoresReportes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fechaInicio: moment().format('YYYY-MM-DD'),
            fechaFin: moment().format('YYYY-MM-DD'),
            idVendedor: null,
            vendedoresOptions: [],
            selectedVendedorOption: null,
            reporteData: null,
            isLoading: false,
            loadingVendedores: false,
            error: null
        };
    }

    componentDidMount() {
        this.fetchVendedores();
    }

    fetchVendedores = async () => {
        this.setState({ loadingVendedores: true });
        try {
            const res = await fetch('/api/vendedores');
            const data = await res.json();
            const options = data.map(v => ({
                value: v.IdVendedor,
                label: `${v.NroDocumento || ''} - ${v.RazonSocial}`
            }));
            this.setState({ vendedoresOptions: options, loadingVendedores: false });
        } catch (e) {
            console.error("Error fetching vendedores:", e);
            this.setState({ loadingVendedores: false, error: "No se pudieron cargar los vendedores" });
        }
    }

    handleChangeFecha = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleChangeVendedor = (selectedOption) => {
        this.setState({
            selectedVendedorOption: selectedOption,
            idVendedor: selectedOption ? selectedOption.value : null
        });
    }

    generarReporte = async () => {
        const { fechaInicio, fechaFin, idVendedor } = this.state;

        this.setState({ isLoading: true, error: null });

        try {
            const query = `fechaInicio=${fechaInicio}&fechaFin=${fechaFin}${idVendedor ? `&idVendedor=${idVendedor}` : ''}`;
            const res = await fetch(`/api/vendedores/reportes?${query}`);

            if (!res.ok) throw new Error("Error al obtener el reporte");

            const data = await res.json();
            this.setState({ reporteData: data, isLoading: false });
        } catch (e) {
            console.error("Error generando reporte:", e);
            this.setState({ isLoading: false, error: e.message });
            Notify(e.message, "error");
        }
    }

    formatCurrency = (amount) => {
        return new Intl.NumberFormat('es-PE', { style: 'currency', currency: 'PEN' }).format(amount || 0);
    }

    formatPercent = (value) => {
        return `${(value || 0).toFixed(2)}%`;
    }

    getDataExportExcel = (vendedores) => {
        return [
            {
                columns: [
                    { title: "Posición", width: { wpx: 80 } },
                    { title: "Nombre Vendedor", width: { wpx: 200 } },
                    { title: "Cant. Facturas", width: { wpx: 100 } },
                    { title: "Total Facturado", width: { wpx: 130 } },
                    { title: "Cant. Vales", width: { wpx: 100 } },
                    { title: "Total Vales", width: { wpx: 130 } },
                    { title: "Cant. Cotizaciones", width: { wpx: 130 } },
                    { title: "Total Cotizaciones", width: { wpx: 140 } },
                    { title: "Promedio Facturas", width: { wpx: 130 } },
                    { title: "Ingresos Totales", width: { wpx: 130 } },
                    { title: "Cotiz. Convertidas", width: { wpx: 130 } },
                    { title: "Monto Cotiz. Convertidas", width: { wpx: 150 } }
                ],
                data: vendedores.map(v => {
                    return [
                        { value: v.posicion, style: { fill: { patternType: "solid", fgColor: { rgb: "F6F8FA" } } } },
                        { value: v.NombreVendedor, style: { fill: { patternType: "solid", fgColor: { rgb: "F6F8FA" } } } },
                        { value: v.cantidadFacturas || 0, style: { fill: { patternType: "solid", fgColor: { rgb: "F6F8FA" } } } },
                        { value: (v.totalFacturado || 0.0).toFixed(2), style: { fill: { patternType: "solid", fgColor: { rgb: "F6F8FA" } } } },
                        { value: v.cantidadVales || 0, style: { fill: { patternType: "solid", fgColor: { rgb: "F6F8FA" } } } },
                        { value: (v.totalVales || 0.0).toFixed(2), style: { fill: { patternType: "solid", fgColor: { rgb: "F6F8FA" } } } },
                        { value: v.totalCotizaciones || 0, style: { fill: { patternType: "solid", fgColor: { rgb: "F6F8FA" } } } },
                        { value: v.montoTotalCotizaciones || 0.0, style: { fill: { patternType: "solid", fgColor: { rgb: "F6F8FA" } } } },
                        { value: v.ticketPromedio || 0.0, style: { fill: { patternType: "solid", fgColor: { rgb: "F6F8FA" } } } },
                        { value: (v.totalIngresos || 0.0).toFixed(2), style: { fill: { patternType: "solid", fgColor: { rgb: "F6F8FA" } } } },
                        { value: v.cotizacionesConvertidas || 0, style: { fill: { patternType: "solid", fgColor: { rgb: "F6F8FA" } } } },
                        { value: v.montoCotizacionesConvertidas || 0.0, style: { fill: { patternType: "solid", fgColor: { rgb: "F6F8FA" } } } }
                    ];
                })
            }
        ];
    }

    renderResumenCards = (resumen) => {
        if (!resumen) return null;

        const MetricCard = ({ title, value, icon, sub, isPercent = false }) => (
            <div className="col-12 col-sm-6 col-md-4 mb-3">
                <div className="card shadow-sm h-100 py-2 border-0" style={{ borderLeft: '4px solid #01a59c', borderRadius: '8px' }}>
                    <div className="card-body py-3">
                        <div className="row no-gutters align-items-center">
                            <div className="col mr-2">
                                <div className="text-muted text-uppercase mb-1" style={{ fontSize: '12px', fontWeight: '600' }}>
                                    {title}
                                </div>
                                <div className="h4 mb-0 font-weight-bold text-dark" style={{ fontSize: '24px' }}>
                                    {isPercent ? <span className="badge badge-light border text-dark" style={{ fontSize: '18px' }}>{value}</span> : value}
                                </div>
                                {sub && <p className="small text-muted mb-0 mt-1">{sub}</p>}
                            </div>
                            <div className="col-auto">
                                <i className={`fas ${icon} fa-2x`} style={{ color: '#01a59c', opacity: '0.8' }}></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        return (
            <div className="row mt-4">
                {/* FILA 1 — Dinero */}
                <MetricCard
                    title="Facturación"
                    value={this.formatCurrency(resumen.totalFacturado)}
                    sub={`${resumen.totalFacturas || 0} facturas emitidas`}
                    icon="fa-cash-register"
                />
                <MetricCard
                    title="Vales"
                    value={this.formatCurrency(resumen.totalVales)}
                    sub={`${resumen.cantidadVales || 0} vales registrados`}
                    icon="fa-receipt"
                />
                <MetricCard
                    title="Ingreso Global"
                    value={this.formatCurrency(resumen.totalIngresos)}
                    sub="Aporte total a la empresa"
                    icon="fa-building"
                />

                {/* FILA 2 — Cotizaciones */}
                <MetricCard
                    title="Cotiz.Emitidas"
                    value={this.formatCurrency(resumen.montoTotalCotizaciones || 0)}
                    sub={`${resumen.totalCotizaciones || 0} cotizaciones emitidas`}
                    icon="fa-file-alt"
                />
                <MetricCard
                    title="Cotiz. Convertidas"
                    value={this.formatCurrency(resumen.montoCotizacionesConvertidas || 0)}
                    sub={`${resumen.cotizacionesConvertidas || 0} cotizaciones convertidas`}
                    icon="fa-exchange-alt"
                />
                <MetricCard
                    title="Tasa Procesadas"
                    value={`${Math.round(resumen.tasaConversionGlobal || 0)}%`}
                    sub={`${resumen.cotizacionesConvertidas || 0} de ${resumen.totalCotizaciones || 0} procesadas`}
                    icon="fa-percentage"
                    isPercent={true}
                />

                {/* FILA 3 — Promedios y Transacciones */}
                <MetricCard
                    title="Ticket Promedio (Fact.)"
                    value={this.formatCurrency(resumen.ticketPromedio)}
                    sub="Promedio por factura emitida"
                    icon="fa-chart-line"
                />
                <MetricCard
                    title="Ticket Prom. Global"
                    value={this.formatCurrency(resumen.ticketPromedioGlobal)}
                    sub="Promedio por cada transacción"
                    icon="fa-globe"
                />
                <MetricCard
                    title="Total Transacciones"
                    value={resumen.cantidadTransacciones || 0}
                    sub={`${resumen.totalFacturas || 0} Fac. + ${resumen.cantidadVales || 0} Vales`}
                    icon="fa-exchange-alt"
                />
            </div>
        );
    }

    renderTable = (vendedores) => {
        if (!vendedores || vendedores.length === 0) return null;

        const resumen = this.state.reporteData?.resumen;

        return (
            <div className="caja-fondo-blanco-m-2 p-3 mt-4 shadow-sm border-0" style={{ borderRadius: '12px' }}>
                <h5 className="mb-3 font-weight-bold" style={{ color: '#01a59c' }}>
                    <i className="fas fa-medal mr-2"></i>Ranking de Desempeño por Vendedor
                </h5>
                <div className="table-responsive">
                    <table className="table table-hover">
                        <thead style={{ backgroundColor: '#01a59c', color: 'white' }}>
                            <tr>
                                <th className="border-0">Pos.</th>
                                <th className="border-0">Nombre</th>
                                <th className="border-0">Cant. Fact.</th>
                                <th className="border-0">Total Facturado</th>
                                <th className="border-0">Cant. Vales</th>
                                <th className="border-0">Total Vales</th>
                                <th className="border-0">Cant. Cotiz. Generadas</th>
                                <th className="border-0">Total Cotiz. Generadas</th>
                                <th className="border-0 text-center">Tasa Conv.</th>
                                <th className="border-0" style={{ width: '180px' }}>% del Total</th>
                            </tr>
                        </thead>
                        <tbody>
                            {vendedores.map((v, i) => {
                                const posEmoji = v.posicion === 1 ? "🥇" : v.posicion === 2 ? "🥈" : v.posicion === 3 ? "🥉" : v.posicion;
                                const conversionBadge = v.tasaConversion >= 75 ? "badge-success" : v.tasaConversion >= 50 ? "badge-warning" : "badge-danger";

                                return (
                                    <tr key={i}>
                                        <td className="font-weight-bold align-middle">{posEmoji}</td>
                                        <td className="align-middle">{v.NombreVendedor}</td>
                                        <td className="font-weight-bold align-center">{v.cantidadFacturas}</td>
                                        <td className="font-weight-bold align-center">{this.formatCurrency(v.totalFacturado)}</td>
                                        <td className="align-center">{v.cantidadVales}</td>
                                        <td className="align-center">{this.formatCurrency(v.totalVales)}</td>
                                        <td className="align-center">{v.totalCotizaciones}</td>
                                        <td className="align-center">{this.formatCurrency(v.montoTotalCotizaciones)}</td>
                                        <td className="align-middle text-center">
                                            <span className={`badge ${conversionBadge} px-3 py-2`} style={{ fontSize: '14px', borderRadius: '20px' }}>
                                                {v.tasaConversion.toFixed(2)}%
                                            </span>
                                        </td>
                                        <td className="align-middle">
                                            <div className="d-flex align-items-center">
                                                <div className="progress flex-grow-1 mr-2" style={{ height: '8px', borderRadius: '4px' }}>
                                                    <div
                                                        className="progress-bar"
                                                        role="progressbar"
                                                        style={{ width: `${v.porcentajeDelTotal}%`, backgroundColor: '#01a59c' }}
                                                        aria-valuenow={v.porcentajeDelTotal}
                                                        aria-valuemin="0"
                                                        aria-valuemax="100"
                                                    ></div>
                                                </div>
                                                <small className="font-weight-bold">{v.porcentajeDelTotal.toFixed(1)}%</small>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                        <tfoot style={{ backgroundColor: '#f0faf9', fontWeight: 'bold' }}>
                            <tr>
                                <td colSpan="2" className="text-right">TOTALES:</td>
                                <td>{resumen?.totalFacturas || 0}</td>
                                <td>{this.formatCurrency(resumen?.totalFacturado || 0)}</td>
                                <td>{resumen?.cantidadVales || 0}</td>
                                <td>{this.formatCurrency(resumen?.totalVales || 0)}</td>
                                <td>{resumen?.totalCotizaciones || 0}</td>
                                <td>{this.formatCurrency(resumen?.montoTotalCotizaciones || 0)}</td>
                                <td colSpan="2"></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        );
    }

    render() {
        const { fechaInicio, fechaFin, selectedVendedorOption, vendedoresOptions, reporteData, isLoading, loadingVendedores, error } = this.state;

        const styleCalendar = {
            border: "none",
            backgroundColor: "transparent",
            color: "#35605a",
            fontWeight: "bold",
            cursor: "pointer",
        };

        return (
            <div className="container-fluid px-4">

                <div className="justify-content-center contenedor-fecha-fpay caja-fondo-blanco-m-2 mt-3 p-2 shadow-sm">
                    <div className="d-flex flex-wrap align-items-center justify-content-center">
                        <div className="mx-3 my-2">
                            <span className="letra-fecha-fpay mr-2">Desde:</span>
                            <input
                                type="date"
                                name="fechaInicio"
                                onChange={this.handleChangeFecha}
                                value={fechaInicio}
                                className="input__linea linea-fecha-fpay"
                                style={styleCalendar}
                                max={moment().format('YYYY-MM-DD')}
                            />
                        </div>
                        <div className="mx-3 my-2">
                            <span className="letra-fecha-fpay mr-2">Hasta:</span>
                            <input
                                type="date"
                                name="fechaFin"
                                onChange={this.handleChangeFecha}
                                value={fechaFin}
                                className="input__linea linea-fecha-fpay"
                                style={styleCalendar}
                                min={fechaInicio}
                                max={moment().format('YYYY-MM-DD')}
                            />
                        </div>
                    </div>
                </div>

                <div className="caja-fondo-blanco-m-2 p-4 mt-3 shadow-sm">
                    <div className="row align-items-end">
                        <div className="col-12 col-md-8 mb-3">
                            <label className="font-weight-bold text-dark">Filtrar por Vendedor (Opcional):</label>
                            <Select
                                value={selectedVendedorOption}
                                onChange={this.handleChangeVendedor}
                                options={vendedoresOptions}
                                placeholder="Todos los Vendedores"
                                isClearable
                                isLoading={loadingVendedores}
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        border: "1px solid #ced4da",
                                        borderRadius: "0.25rem",
                                        minHeight: "45px"
                                    })
                                }}
                            />
                        </div>
                        <div className="col-12 col-md-4 mb-3">
                            <button
                                className="btn btn-primary btn-block shadow-sm"
                                style={{ height: "45px", fontWeight: "bold" }}
                                onClick={this.generarReporte}
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <><span className="spinner-border spinner-border-sm mr-2"></span>Cargando...</>
                                ) : (
                                    <><i className="fas fa-search mr-2"></i>Generar Reporte</>
                                )}
                            </button>
                        </div>
                    </div>
                </div>

                {error && (
                    <div className="alert alert-danger mt-3 shadow-sm border-left-danger">
                        <i className="fas fa-exclamation-triangle mr-2"></i>
                        {error}
                    </div>
                )}

                {reporteData && (
                    <>
                        {this.renderResumenCards(reporteData.resumen)}
                        <div className="d-flex justify-content-end m-3">
                            <button className="bg-none border-none" style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                                <ExcelFile
                                    element={
                                        <button className="boton__verdeOscuro">
                                            <i className="fas fa-file-excel"></i>
                                        </button>
                                    }
                                    filename={`Reporte_Vendedores_${moment().format("YYYY-MM-DD")}`}
                                >
                                    <ExcelSheet
                                        dataSet={this.getDataExportExcel(reporteData.vendedores)}
                                        name="Vendedores"
                                    ></ExcelSheet>
                                </ExcelFile>
                            </button>
                        </div>
                        {this.renderTable(reporteData.vendedores)}
                    </>
                )}

                {!reporteData && !isLoading && !error && (
                    <div className="caja-fondo-blanco-m-2 p-5 mt-5 shadow-sm text-center border-0" style={{ borderRadius: '15px' }}>
                        <div className="py-4">
                            <i className="fas fa-chart-bar fa-5x mb-4" style={{ color: '#01a59c', opacity: '0.5' }}></i>
                            <h2 className="font-weight-bold text-dark">Sin datos aún</h2>
                            <p className="text-muted mb-4" style={{ fontSize: '18px' }}>
                                Selecciona el rango de fechas y presiona Generar Reporte para visualizar el desempeño de tus vendedores.
                            </p>
                            <button
                                className="btn btn-outline-primary px-5 py-2"
                                style={{ borderColor: '#01a59c', color: '#01a59c', fontWeight: 'bold', borderRadius: '30px' }}
                                onClick={() => this.generarReporte()}
                            >
                                <i className="fas fa-play mr-2"></i>Generar Reporte Ahora
                            </button>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default VendedoresReportes;
